import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { translate } from 'react-i18next';
import i18n from '../../i18n';
import InnerHtmlContent from '../InnerHtmlContent';

class ServiceInfoBox extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      show: true
    };
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const { t } = this.props;
    const title = t('serviceInfo.title');
    const content = t('serviceInfo.content');
    const hasTitle = i18n.exists('serviceInfo.title');
    const hasContent = i18n.exists('serviceInfo.content');

    if (this.state.show && (hasTitle || hasContent)) {
      return (
        <div className={'service-info-box'}>
          <Alert bsStyle="warning" onDismiss={this.handleDismiss}>
            {title.length > 0 &&
              <h4 className={'title'}>
                <InnerHtmlContent content={t('serviceInfo.title')} />
              </h4>
            }
            {content.length > 0 &&
              <p className={'content'}>
                <InnerHtmlContent content={t('serviceInfo.content')} />
              </p>
            }
          </Alert>
        </div>
      );
    }
    return null;
  }
}

ServiceInfoBox.propTypes = {
  t: PropTypes.func.isRequired
};

export default translate(['common'], { wait: true })(ServiceInfoBox);



// WEBPACK FOOTER //
// ./src/components/ServiceInfoBox/index.jsx